// ============================================================
// BOSCO — Helper toasts partagé (UI-D1, charte V3.1)
//
// Expose :
//   - afficherToastSucces(message)     → toast émeraude auto-dismiss 3s
//   - afficherToastErreur(message)     → toast rouge auto-dismiss 5s
//   - marquerBoutonChargement(bouton, enChargement)
//        → toggle .is-loading + injection/retrait d'un .spinner-bouton
//
// Les toasts utilisent les classes CSS `.toast-succes` et `.toast-echec-put`
// définies dans style.css. CSP-safe : pas d'innerHTML avec données utilisateur.
// ============================================================

(function () {
    'use strict';

    const DUREE_SUCCES = 3000;
    const DUREE_ERREUR = 5000;

    function creerToast(classe, message) {
        const toast = document.createElement('div');
        toast.className = classe;
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');

        const icone = document.createElement('span');
        icone.className = classe + '__icone';
        icone.setAttribute('aria-hidden', 'true');
        icone.textContent = classe === 'toast-succes' ? '✓' : '⚠';

        const texte = document.createElement('span');
        texte.className = classe + '__texte';
        texte.textContent = message;

        const fermer = document.createElement('button');
        fermer.type = 'button';
        fermer.className = classe + '__fermer';
        fermer.setAttribute(
            'aria-label',
            (window.traduire && window.traduire('BOSCO.Commun.Fermer', 'Fermer')) || 'Fermer',
        );
        fermer.textContent = '×';
        fermer.addEventListener('click', () => toast.remove());

        toast.append(icone, texte, fermer);
        return toast;
    }

    function afficherToastSucces(message) {
        const toast = creerToast('toast-succes', message);
        document.body.appendChild(toast);
        setTimeout(() => {
            if (toast.isConnected) toast.remove();
        }, DUREE_SUCCES);
        return toast;
    }

    function afficherToastErreur(message) {
        const toast = creerToast('toast-echec-put', message);
        document.body.appendChild(toast);
        setTimeout(() => {
            if (toast.isConnected) toast.remove();
        }, DUREE_ERREUR);
        return toast;
    }

    function marquerBoutonChargement(bouton, enChargement) {
        if (!bouton) return;
        if (enChargement) {
            if (bouton.classList.contains('is-loading')) return;
            bouton.classList.add('is-loading');
            bouton.setAttribute('aria-busy', 'true');
            const spinner = document.createElement('span');
            spinner.className = 'spinner-bouton';
            spinner.dataset.boscoSpinner = '1';
            spinner.setAttribute('aria-hidden', 'true');
            bouton.prepend(spinner);
        } else {
            bouton.classList.remove('is-loading');
            bouton.removeAttribute('aria-busy');
            const spinner = bouton.querySelector('.spinner-bouton[data-bosco-spinner]');
            if (spinner) spinner.remove();
        }
    }

    window.afficherToastSucces = afficherToastSucces;
    window.afficherToastErreur = afficherToastErreur;
    window.marquerBoutonChargement = marquerBoutonChargement;
})();
